var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagePrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5866 0C22.3746 0 24.0946 0.706667 25.36 1.97467C26.6266 3.24 27.3346 4.94667 27.3346 6.73333V17.2667C27.3346 20.9867 24.308 24 20.5866 24H7.41463C3.6933 24 0.667969 20.9867 0.667969 17.2667V6.73333C0.667969 3.01333 3.67997 0 7.41463 0H20.5866ZM22.708 8.72L22.8146 8.61333C23.1333 8.22667 23.1333 7.66667 22.8 7.28C22.6146 7.08133 22.36 6.96 22.0946 6.93333C21.8146 6.91867 21.548 7.01333 21.3466 7.2L15.3346 12C14.5613 12.6413 13.4533 12.6413 12.668 12L6.66797 7.2C6.2533 6.89333 5.67997 6.93333 5.33464 7.29333C4.97464 7.65333 4.93464 8.22667 5.23997 8.62667L5.41464 8.8L11.4813 13.5333C12.228 14.12 13.1333 14.44 14.0813 14.44C15.0266 14.44 15.948 14.12 16.6933 13.5333L22.708 8.72Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagePrimary);
export default __webpack_public_path__ + "static/media/message-primary.9fd45ae62ba421ba9845d16ab20a1edb.svg";
export { ForwardRef as ReactComponent };